module.exports = {"513225101":"漳扎镇","513225102":"南坪镇","513225103":"双河镇","513225104":"黑河镇","513225105":"勿角镇","513225201":"永和乡","513225203":"白河乡","513225205":"保华乡","513225209":"郭元乡","513225210":"草地乡","513225213":"玉瓦乡","513225214":"大录乡","513225400":"九寨沟国营牧场","513225401":"九寨沟风景名胜管理局"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513225.json
// module id = 2534
// module chunks = 0